import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AcknowledgementComponent } from './acknowledgement/acknowledgement.component';
import { BrAcknowledgementComponent } from './acknowledgement/br-acknowledgement/br-acknowledgement.component';
import { OusAcknowledgementComponent } from './acknowledgement/ous-acknowledgement/ous-acknowledgement.component';
import { AddressHistoryComponent } from './address-history/address-history.component';
import { Authguard } from './auth/authguard';
import { AuthguardMain } from './auth/authguard.main';
import { AuthguardAAToken } from './auth/authguard.aa.token';
import { AuthguardAAApplicant } from './auth/authguard.aa.applicant';
import { AuthguardDisputeInitiated } from './auth/authguard.dispute.initiated';
import { AuthguardDisputeApplicant } from './auth/authguard.dispute.applicant';
import { CertificationComponent } from './certification/certification.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { CreateProfileComponent } from './create-profile/create-profile.component';
import { CriminalHistoryComponent } from './criminal-history/criminal-history.component';
import { EducationHistoryComponent } from './education-history/education-history.component';
import { EmploymentHistoryComponent } from './employment-history/employment-history.component';
import { FcraAuthorizationComponent } from './fcra-authorization/fcra-authorization.component';
import { ForgotPasswordOTPComponent } from './forgot-password-otp/forgot-password-otp.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { IntroductionComponent } from './introduction/introduction.component';
import { LoginComponent } from './login/login.component';
import { OtherBackgroundCheckComponent } from './other-background-check/other-background-check.component';
import { PersonalInformationComponent } from './personal-information/personal-information.component';
import { ProfessionalCertificationComponent } from './professional-certification/professional-certification.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SecurityQuestionsComponent } from './security-questions/security-questions.component';
import { SuccessPasswordComponent } from './success-password/success-password.component';
import { SuccessProfileComponent } from './success-profile/success-profile.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { VersionComponent } from './version/version.component';
import { LoadingComponent } from './loading/loading.component';
import { SummaryOfRightsComponent } from './other-background-check/summary-of-rights/summary-of-rights.component';
import { SessionTimedOutComponent } from './session-timed-out/session-timed-out.component';
import { CpaComponent } from './cpa/cpa.component';
import { SubmitCompleteComponent } from './submit-complete/submit-complete.component';
import { LatestAALetterComponent } from './latest-aaletter/latest-aaletter.component';
import { DisputeQuestionnaireComponent } from './dispute-questionnaire/dispute-questionnaire.component';
import { DisputeAlreadySubmittedComponent } from './dispute-already-submitted/dispute-already-submitted.component';
import { I9Component } from './i9/i9.component';
import { PcMbamComponent } from './pc-mbam/pc-mbam.component';
import { PCGBAMComponent } from './pc-gbam/pc-gbam.component';
import { PcSurveyComponent } from './pc-survey/pc-survey.component';
import { AuthguardVendor } from './auth/authguard.vendor';
import { CreateVendorProfileComponent } from './create-vendor-profile/create-vendor-profile.component';
import { VendorDashboardComponent } from './vendor-dashboard/vendor-dashboard.component';
import { AccountLockedComponent } from './account-locked/account-locked.component';
import { DirectorshipComponent } from './directorship/directorship.component';
import { CriminalRecordCertificateComponent } from './criminal-history/criminal-record-certificate/criminal-record-certificate.component';
import { AuthguardNHP } from './auth/authguard.nhp';
import { AuthTitle } from './auth/auth-title';
import { AuthguardCredentials } from './auth/authguard.credentials';
import { FitnessProprietyComponent } from './fitness-propriety/fitness-propriety.component';



const routes: Routes = [{
  path: 'registration',
  component: LoadingComponent,
  canActivate: [AuthguardMain]
},
{
  path: 'nhpAF',
  component: LoadingComponent,
  canActivate: [AuthguardNHP]
},
{
  path: 'registrationVendor',
  component: LoadingComponent,
  canActivate: [AuthguardVendor]
},
{
  path: 'viewAAGeneratedLetter',
  component: LoadingComponent,
  canActivate: [AuthguardAAToken]
},
{
  path: 'loginLatestAAGenLetter',
  component: LoadingComponent,
  canActivate: [AuthguardAAApplicant]
},
{
  path: 'latestAAGenLetter',
  component: LatestAALetterComponent,
  canActivate: [AuthTitle],
  data: { title: 'Latest AA Generated Letter' }
},
{
  path: 'disputeRegistration',
  component: LoadingComponent,
  canActivate: [AuthguardDisputeInitiated]
},
{
  path: 'loginDisputeRegistration',
  component: LoadingComponent,
  canActivate: [AuthguardDisputeApplicant]
},
{
  path: 'disputeAlreadySubmitted',
  component: DisputeAlreadySubmittedComponent,
  canActivate: [AuthTitle],
  data: { title: 'Dispute Already Submitted' }
},
{
  path: 'disputeQuestionnaire',
  component: DisputeQuestionnaireComponent,
  canActivate: [AuthTitle],
  data: { title: 'Dispute Questionnaire' }
},
{
  path: 'vendorDashboard',
  component: VendorDashboardComponent,
  canActivate: [AuthTitle],
  data: { title: 'Vendor Dashboard' }
},
{
  path: 'introduction',
  component: IntroductionComponent,
  canActivate: [Authguard],
  data: { title: 'Introduction' }
},
{
  path: 'authorization',
  component: FcraAuthorizationComponent,
  canActivate: [Authguard],
  data: { title: 'FCRA Disclosure and Authorization' }
},
{
  path: 'otherBackgroundCheck',
  component: OtherBackgroundCheckComponent,
  canActivate: [Authguard],
  data: { title: 'Other Background Check Information' }
},
{
  path: 'personalInformation',
  component: PersonalInformationComponent,
  canActivate: [Authguard],
  data: { title: 'Personal Information' }
},
{
  path: 'addressHistory',
  component: AddressHistoryComponent,
  canActivate: [Authguard],
  data: { title: 'Address History' }
},
{
  path: 'cpa',
  component: CpaComponent,
  canActivate: [Authguard],
  data: { title: 'Consumer Privacy Act' }
},
{
  path: 'employmentHistory',
  component: EmploymentHistoryComponent,
  canActivate: [Authguard],
  data: { title: 'Employment History' }
},
{
  path: 'educationHistory',
  component: EducationHistoryComponent,
  canActivate: [Authguard],
  data: { title: 'Education History' }
},
{
  path: 'professionalCertification',
  component: ProfessionalCertificationComponent,
  canActivate: [Authguard],
  data: { title: 'Professional Certification History' }
},
{
  path: 'criminalHistory',
  component: CriminalHistoryComponent,
  canActivate: [Authguard],
  data: { title: 'Criminal History' }
},
{
  path: 'criminalRecordCertificate',
  component: CriminalRecordCertificateComponent,
  canActivate: [Authguard],
  data: { title: 'Criminal Record Certificate' }
},
{
  path: 'fitnessPropriety',
  component: FitnessProprietyComponent,
  canActivate: [Authguard],
  data: { title: 'Fitness and Propriety Questions' }
},
{
  path: 'locationConfirmation',
  component: I9Component,
  canActivate: [Authguard],
  data: { title: 'Location Confirmation' }
},
{
  path: 'pc-gbam',
  component: PCGBAMComponent,
  canActivate: [Authguard],
  data: { title: 'Political Contributions' }
},
{
  path: 'pc-mbam',
  component: PcMbamComponent,
  canActivate: [Authguard],
  data: { title: 'Political Contributions' }
},
{
  path: 'pc-survey',
  component: PcSurveyComponent,
  canActivate: [Authguard],
  data: { title: 'Political Contributions' }
},
{
  path: 'certification',
  component: CertificationComponent,
  canActivate: [Authguard],
  data: { title: 'Certification' }
},
{
  path: 'acknowledgement',
  component: AcknowledgementComponent,
  canActivate: [Authguard],
  data: { title: 'Acknowledgement of Employment Terms and Information' }
},
{
  path: 'br-acknowledgement',
  component: BrAcknowledgementComponent,
  canActivate: [Authguard],
  data: { title: 'Acknowledgement of Employment Terms and Information' }
},
{
  path: 'ous-acknowledgement',
  component: OusAcknowledgementComponent,
  canActivate: [Authguard],
  data: { title: 'Acknowledgement of Employment Terms and Information' }
},
{
  path: 'ous-directorship',
  component: DirectorshipComponent,
  canActivate: [Authguard],
  data: { title: 'Directorship' }
},
{
  path: 'login',
  component: LoginComponent,
  canActivate: [AuthTitle],
  data: { title: 'Login' }
},
{
  path: 'unauthorized',
  component: UnauthorizedComponent,
  canActivate: [AuthTitle],
  data: { title: 'Unauthorized' }
}, {
  path: 'accountLocked',
  component: AccountLockedComponent,
  canActivate: [AuthTitle],
  data: { title: 'Account Locked' }
},
{
  path: 'summaryOfRights',
  component: SummaryOfRightsComponent,
  canActivate: [AuthTitle],
  data: { title: 'Summary of Rights' }
},
{
  path: 'createAccount',
  component: CreateProfileComponent,
  canActivate: [AuthTitle],
  data: { title: 'Create Account' }
},
{
  path: 'createVendorAccount',
  component: CreateVendorProfileComponent,
  canActivate: [AuthTitle],
  data: { title: 'Create Vendor Account' }
},
{
  path: 'forgotPassword',
  component: ForgotPasswordComponent,
  canActivate: [AuthTitle],
  data: { title: 'Forgot Password' }
},
{
  path: 'changePassword',
  component: ChangePasswordComponent,
  canActivate: [AuthTitle],
  data: { title: 'Change Password' }
},
{
  path: 'successProfile',
  component: SuccessProfileComponent,
  canActivate: [AuthTitle],
  data: { title: 'Success Profile' }
},
{
  path: 'forgotPasswordOTP',
  component: ForgotPasswordOTPComponent,
  canActivate: [AuthTitle],
  data: { title: 'Forgot Password OTP' }
},
{
  path: 'securityQuestions',
  component: SecurityQuestionsComponent,
  canActivate: [AuthTitle],
  data: { title: 'Security Questions' }
},
{
  path: 'resetPassword',
  component: ResetPasswordComponent,
  canActivate: [AuthguardCredentials],
  data: { title: 'Reset Password' }
},
{
  path: 'successPassword',
  component: SuccessPasswordComponent,
  canActivate: [AuthTitle],
  data: { title: 'Change Password Success' }
},
{
  path: 'version',
  component: VersionComponent,
  canActivate: [AuthTitle],
  data: { title: 'Version' }
},
{
  path: 'sessionTimedOut',
  component: SessionTimedOutComponent,
  canActivate: [AuthTitle],
  data: { title: 'Session Timed out' }
},
{
  path: 'submitComplete',
  component: SubmitCompleteComponent,
  canActivate: [AuthTitle],
  data: { title: 'Submit Complete' }
},
{
  path: '**',
  redirectTo: '/unauthorized',
  pathMatch: 'full'
}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
